import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const urlSchema = z.object({ url: z.string().url() });

export const previewResponseSchema = z.object({
  url: z.string().url().nullable(),
  retryAfter: z.number().optional(), // milliseconds until next retry
  queueFull: z.boolean().optional(), // true if queue is at capacity
});

export class UrlDto extends createZodDto(urlSchema) {}

export class PreviewResponseDto extends createZodDto(previewResponseSchema) {}
